export enum RoutesName {
  PERFORMANCE = 'performance',
  ANALYTICS = 'analytics',
  DISPATCH_PORTFOLIO = 'dispatch-portfolio',
  DISPATCH_SITE = 'dispatch-site',
  UNAUTHORIZED = 'unauthorized',
  PROGRAM = 'program',
  PORTFOLIO = 'portfolio',
  ORGANIZATION = 'organization',
  SITE = 'site',
  EVENT_DETAILS = 'event-details',
  ROOT = '',
}

export const TABS_ORDER = [RoutesName.PERFORMANCE, RoutesName.ANALYTICS];
